import {useQuery} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {AgentInfo} from '../types/session'

export function generateAgentInfoQueryKey(agentId: number | undefined | null) {
  return ['agent-info', agentId]
}

/**
 *
 * This hook fetches agent metadata (name, avatar, etc.) from the monolith
 * for agents that are returned from CAPI sessions but don't include
 * full agent information.
 *
 */
export function useAgentInfo(agentId: number | undefined | null) {
  return useQuery<AgentInfo>({
    queryKey: generateAgentInfoQueryKey(agentId),
    queryFn: async () => {
      const response = await reactFetchJSON(`/copilot/agent-sessions/agents/${agentId}`)

      if (!response.ok) {
        throw new Error(`Failed to fetch agent info for agent ${agentId}`)
      }

      const data = await response.json()
      return data.agent_info
    },
    enabled: !!agentId,
    staleTime: Infinity,
  })
}
